import { CreationContext } from '@backoffice-frontend/report-io-lib'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { ClipboardListIcon } from '@moia-dev/pace-icons'
import { ActionItem } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { useAdOperatorReportIo } from './useAdOperatorReportIo'

type AdOperatorReportIoActionItemProps = {
  vehicleId: string
  onClick?: VoidFunction
}

export const AdOperatorReportIoActionItem = ({
  vehicleId,
  onClick,
}: AdOperatorReportIoActionItemProps) => {
  const { t } = useTranslation()
  const { openReportDialog } = useAdOperatorReportIo()
  const hasRightsToReportProblem = useUserHasAccess({
    requiredRights: [
      BoumRight.REPORT_ACCIDENT_CRUD,
      BoumRight.REPORT_DISRUPTION_CRUD,
    ],
  })

  return (
    <ActionItem
      disabled={!hasRightsToReportProblem}
      label={t('adOperatorReportIo_reportProblem_actionItemLabel')}
      leading={<ClipboardListIcon />}
      onClick={() => {
        openReportDialog({
          vehicleId,
          creationContext: CreationContext.FleetMapDocumentProblem,
        })
        onClick?.()
      }}
    />
  )
}
